// SunPress Solar — official brand assets.
// Images are locally hosted, WebP-compressed (~90% smaller than originals) for performance.
// Only assets that show publicly-announced products are included here.
export const BRAND_ASSETS = {
  logo: "/img/logo.webp",

  // 5-product CERTIFIED family (Iron + Power Station + Sewing + Fan + Blender)
  family5Certified: "/img/family5.webp",

  // Solo Solar Blender render
  blenderSolo: "/img/blender.webp",

  // 4-product family (Iron + Sewing + Fan + Blender) — publicly announced lineup
  family4: "/img/family4.webp",

  // CORE 500 real product photo (still from HD-4001 studio video)
  packaging: "/img/core500-1.webp",

  // Campaign lifestyle photo — tailor with the CORE 500 retail box (hero fallback until video arrives)
  heroImage: "/img/hero-tailor.webp",

  // 30–60s demo film ("See CORE 500 in Action") — set to MP4 URL when the user uploads it.
  demoVideo: "/media/factory.mp4",
  demoVideoPoster: "/img/factory-poster.webp",
  // Campaign key visual — "Power Smart. Press Confidently." (poster for the demo slot)
  campaignPoster: "/img/campaign-poster.webp",

  // Hero brand video — 10s campaign film (1280×720, H.264), served locally.
  heroVideo: "/media/campaign.mp4",
  // Optional poster image shown before the video plays (also used as the still preview frame).
  heroVideoPoster: "/img/campaign-poster.webp",

  // "See it in action" clips. Leave a src empty to show a "filming now" placeholder instead.
  fabricTestVideo: "/media/core500-demo.mp4",
  fabricTestPoster: "/img/core500-demo-poster.webp",
  inverterTestVideo: "",
  inverterTestPoster: "/img/campaign-poster.webp",
  factoryQaVideo: "/media/production-testing.mp4",
  factoryQaPoster: "/img/production/prod-still-2.webp",
};
